<template>
  <el-dialog :visible.sync="dialogVisible" width="700px" :before-close="handleClose" class="invoice-dialog" :close-on-press-escape="false" :close-on-click-modal="false" ref="dialog" :loading="loading">
    <div slot="title">
      付款方/发票信息
      <span class="title-tips">（请准确填写，该信息将作为您所申请服务的开票信息被我们采用）</span>
    </div>
    <div class="invoice-content" v-loading="loading">
      <div class="invoice-type">
        <div class="label">发票类型</div>
        <div>
          <el-radio-group v-model="type1">
            <el-radio :label="1" :disabled="isEdit || isAdd">增值税电子普通发票</el-radio>
            <el-radio :label="2" :disabled="isEdit || isAdd">增值税电子专用发票</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="invoice-type" v-if="type1 === 1" style="margin-bottom: 10px;">
        <div class="label">抬头类型</div>
        <div>
          <el-radio-group v-model="type2">
            <el-radio :label="1" :disabled="isEdit || isAdd">公司</el-radio>
            <!--<br>-->
            <el-radio :label="2" :disabled="isEdit || isAdd">个人</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div class="invoice-list">
        <div v-for="(item, index) in list" :key="index">
          <div class="invoice-list-item" v-if="index !== list.length - 1">
            <div class="label">{{index === 0 ? '发票抬头' : ''}}</div>
            <div class="invoice-item" :class="{'is-disabled': isEdit || isAdd}">
              <div class="invoice-item-detail" @click="chooseInvoice(item, index)" :class="{'is-active': item.invoiceId === activeInvoice.invoiceId}">
                {{item.invoiceTitle}}
                <img src="../../assets/images/bottom-select.png" alt="">
              </div>
              <div class="edit-btn" style="margin-right: 15px;" @click="editInvoice(item)">修改</div>
              <div class="edit-btn" v-if="item.invoiceId !== activeInvoice.invoiceId" @click="delInvoice(item.invoiceId)">删除</div>
            </div>
          </div>
          <div class="invoice-detail" v-if="!isEdit && activeInvoice.invoiceId === item.invoiceId && index !== list.length - 1">
            <div class="label"></div>
            <div class="detail-list" v-if="invoiceType !== 2">
              <template v-if="activeInvoice.isForeign===1">
                <div class="detail-item">
                  <span class="detail-label">公司名称：</span>
                  <span class="detail-content">{{item.invoiceTitle}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">国家及地区：</span>
                  <span class="detail-content">{{item.country}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">城市：</span>
                  <span class="detail-content">{{item.foreignCity}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">地址：</span>
                  <span class="detail-content">{{item.regAddress}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">邮编：</span>
                  <span class="detail-content">{{item.postCode}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">联系人：</span>
                  <span class="detail-content">{{item.contact}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">电话：</span>
                  <span class="detail-content">{{item.regPhone}}</span>
                </div>
              </template>
              <template v-else>
                <div class="detail-item">
                  <span class="detail-label">税号：</span>
                  <span class="detail-content">{{item.taxNo}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">公司地址：</span>
                  <span class="detail-content">{{item.regAddress}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">公司电话：</span>
                  <span class="detail-content">{{item.regPhone}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">开户银行：</span>
                  <span class="detail-content">{{item.bankName}}</span>
                </div>
                <div class="detail-item">
                  <span class="detail-label">银行账号：</span>
                  <span class="detail-content">{{item.bankNumber}}</span>
                </div>
                <div class="detail-item" style="display: flex;align-items: flex-start" v-if="activeInvoice.frontImg || activeInvoice.backImg">
                  <span class="detail-label">营业执照：</span>
                  <template v-if="activeInvoice.frontImg">
                  <span class="yingye-img">
                    <img :src="getImgUrl(activeInvoice.frontImg[0] && activeInvoice.frontImg[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.frontImg[0])">
                  </span>
                  </template>
                  <template v-if="activeInvoice.backImg">
                  <span class="yingye-img">
                    <img :src="getImgUrl(activeInvoice.backImg[0] && activeInvoice.backImg[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.backImg[0])">
                  </span>
                  </template>
                </div>
<!--                <div class="detail-item" style="display: flex;align-items: flex-start" v-if="activeInvoice.otherFileList && activeInvoice.otherFileList.length">
                  <span class="detail-label">盖公章的<br>开票资料：</span>
                  <template v-for="file in currentOtherFile">
                  <span class="yingye-img" :key="file.fileId">
                    <img :src="getImgUrl(file.fileUrl)" alt="" @click="downloadFile(file)">
                  </span>
                  </template>
                </div>-->
              </template>

            </div>
            <div class="detail-list" v-if="invoiceType === 2">
              <div class="detail-item">
                <span class="detail-label">姓名：</span>
                <span class="detail-content">{{item.invoiceTitle}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">联系电话：</span>
                <span class="detail-content">{{item.regPhone}}</span>
              </div>
              <div class="detail-item">
                <span class="detail-label">身份证号：</span>
                <span class="detail-content">{{item.taxNo}}</span>
              </div>
            </div>
          </div>
          <div class="invoice-list-item" v-if="!isAdd && !isEdit && index === list.length - 1">
            <div class="label">{{list.length > 1 ? '' : '发票抬头'}}</div>
            <div class="add-btn" @click="addInvoice">
              <span class="add-btn-icon">+</span>新增发票抬头
            </div>
          </div>
          <div class="edit-invoice" v-loading="invoiceLoading" v-if="(isEdit && activeInvoice.invoiceId === item.invoiceId) || (isAdd && index === list.length - 1)">
            <div class="label">{{isAdd ? '新增发票' : '修改发票'}}</div>
            <el-form :model="activeInvoice" :rules="rules" ref="ruleForm" label-width="95px" class="invoice-form">
              <div class="form-title">
                {{isAdd?'新增':'修改'}}发票抬头
                <el-checkbox v-model="activeInvoice.isForeign" :true-label="1" :false-label="0" style="float:right;" v-if="invoiceType!==2">境外及港澳台公司</el-checkbox>
              </div>
              <template v-if="invoiceType === 2">
                <el-form-item label="姓名" prop="invoiceTitle">
                  <el-input v-model="activeInvoice.invoiceTitle" maxlength="25"></el-input>
                </el-form-item>
                <el-form-item label="联系电话" prop="regPhone">
                  <el-input v-model="activeInvoice.regPhone" maxlength="50"></el-input>
                </el-form-item>
                <el-form-item label="身份证号" prop="taxNo">
                  <el-input v-model="activeInvoice.taxNo" maxlength="18"></el-input>
                </el-form-item>
              </template>
              <template v-if="invoiceType !== 2">
                <template v-if="activeInvoice.isForeign===1">
                  <el-form-item label="公司名称" prop="invoiceTitle" key="invoiceTitle1">
                    <el-input v-model="activeInvoice.invoiceTitle" maxlength="200" placeholder="请输入英文"></el-input>
                  </el-form-item>
                  <el-form-item label="国家及地区" prop="country" key="country1">
                    <el-input v-model="activeInvoice.country" maxlength="200" placeholder="请输入英文"></el-input>
                  </el-form-item>
                  <el-form-item label="城市" prop="foreignCity" key="foreignCity1">
                    <el-input v-model="activeInvoice.foreignCity" maxlength="200" placeholder="请输入英文"></el-input>
                  </el-form-item>
                  <el-form-item label="地址" prop="regAddress" key="regAddress1">
                    <el-input v-model="activeInvoice.regAddress" maxlength="200" placeholder="请输入英文"></el-input>
                  </el-form-item>
                  <el-form-item label="邮编" prop="postCode" key="postCode1">
                    <el-input v-model="activeInvoice.postCode" maxlength="200"></el-input>
                  </el-form-item>
                  <el-form-item label="联系人" prop="contact" key="contact1">
                    <el-input v-model="activeInvoice.contact" maxlength="200" placeholder="请输入英文"></el-input>
                  </el-form-item>
                  <el-form-item label="电话" prop="regPhone" key="regPhone1" class="is-required">
                    <el-input v-model="activeInvoice.regPhone" maxlength="50"></el-input>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item label="公司名称" prop="invoiceTitle" key="invoiceTitle2">
                    <el-popover placement="bottom-start" width="369" trigger="manual" v-model="titleTipsVisible" popper-class="invoice-tips">
                      <div style="color:#ca4300;height:100px;" v-if="isCs">请输入至少3个文字，系统将自动匹配公司信息</div>
                      <div class="tips" v-else>
                        {{noList&&activeInvoice.invoiceTitle.length > 3?'未匹配到信息，请继续或重新输入':'请输入至少4个文字，系统将自动匹配公司名称和税号'}}
                      </div>
                      <el-autocomplete slot="reference" :maxlength="200" style="width: 369px;" ref="autocomplete" v-model="activeInvoice.invoiceTitle" :fetch-suggestions="querySearchAsync" @select="handleSelect" placeholder="" highlight-first-item :trigger-on-focus="false" @focus="titleFocus(true)" @blur="titleTipsVisible = false" @input="titleFocus(false)" :popper-class="isCs?'company-popper':'invoice-popper'">
                        <template slot-scope="{ item }">
                          <div class="autocomplete-item" v-if="isCs">
                            <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                            <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",") }}</span>
                            <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                            <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                          </div>
                          <div v-else style="font-size: 12px;line-height: 18px;padding: 9px 0 7px;">
                            <div style="color: #333;">{{item.name}}</div>
                            <div style="color: #878787;">税号：{{item.creditCode}}</div>
                          </div>
                        </template>
                      </el-autocomplete>
                    </el-popover>
                    <!--                  <el-input v-model="activeInvoice.invoiceTitle" maxlength="200" v-else></el-input>-->
                  </el-form-item>
                  <el-form-item label="税号" prop="taxNo" key="taxNo2">
                    <div style="display: flex;justify-content: space-between;align-items: center;width: 100%;">
                      <el-popover placement="bottom-start" width="369" trigger="manual" v-model="noTipsVisible" v-if="isCs">
                        <div style="color:#ca4300;height:100px;">请输入至少5位编码，系统将自动匹配公司信息</div>
                        <el-autocomplete slot="reference" :maxlength="20" style="width: 369px;" ref="autocomplete" v-model="activeInvoice.taxNo" :fetch-suggestions="querySearchAsync1" @select="handleSelect" placeholder="" highlight-first-item :trigger-on-focus="false" @focus="noFocus" @blur="noTipsVisible = false" @input="noFocus" popper-class="company-popper">
                          <template slot-scope="{ item }">
                            <div class="autocomplete-item">
                              <span class="autocomplete-item-name" v-html="item.customerNameCn || '空'"></span>
                              <span class="autocomplete-item-org">{{ item.siteInfo.map(v => v.organizationName).join(",") }}</span>
                              <span class="autocomplete-item-address">{{ item.addressCn }}</span>
                              <span class="autocomplete-item-date">{{ item.createdDate }}</span>
                            </div>
                          </template>
                        </el-autocomplete>
                      </el-popover>
                      <el-input v-model="activeInvoice.taxNo" maxlength="20" style="width: 369px;" v-else></el-input>
                    </div>
                  </el-form-item>
                  <el-form-item label="公司地址" prop="regAddress" key="regAddress2">
                    <el-input v-model="activeInvoice.regAddress" maxlength="200"></el-input>
                  </el-form-item>
                  <el-form-item label="公司电话" prop="regPhone" key="regPhone2">
                    <el-input v-model="activeInvoice.regPhone" maxlength="50"></el-input>
                  </el-form-item>
                  <el-form-item label="" prop="bankName" key="bankName2">
                    <template slot="label">
                      开户银行
                      <el-tooltip class="item" effect="dark" content="请填写到支行信息" placement="top-start">
                        <!-- <span class="tip-icon">！</span> -->
                      </el-tooltip>
                    </template>
                    <el-input v-model="activeInvoice.bankName" maxlength="200"></el-input>
                  </el-form-item>
                  <el-form-item label="银行账号" prop="bankNumber" key="bankNumber2">
                    <el-input v-model="activeInvoice.bankNumber" maxlength="30"></el-input>
                  </el-form-item>
                  <div class="upload-tips">请上传企业验证信息</div>
                  <!--                <el-form-item label="营业执照" prop="frontImg" class="is-required img-item" v-if="imgRequired">-->
                  <el-form-item label="营业执照" prop="frontImg" class="img-item" :class="{'is-required': imgRequiredShow}" style="margin-bottom: 45px;">
                    <template v-if="activeInvoice.frontImg">
                    <span class="yingye-img">
                      <img :src="getImgUrl(activeInvoice.frontImg[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.frontImg[0])">
                      <span class="del-icon" @click="delImg('frontImg', 'frontImg')"></span>
                    </span>
                    </template>
                    <template v-if="activeInvoice.backImg">
                    <span class="yingye-img">
                      <img :src="getImgUrl(activeInvoice.backImg[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.backImg[0])">
                      <span class="del-icon" @click="delImg('backImg', 'frontImg')"></span>
                    </span>
                    </template>
                    <upload-file bindKey="frontImg"
                                 :apiUrl="host.javaUrl"
                                 :apis="apis"
                                 :limit="1"
                                 :type="1"
                                 v-model="activeInvoice.frontImg"
                                 v-if="!activeInvoice.frontImg"></upload-file>
                    <upload-file bindKey="backImg"
                                 :apiUrl="host.javaUrl"
                                 :apis="apis"
                                 :limit="1"
                                 :type="1"
                                 v-model="activeInvoice.backImg"
                                 v-if="!activeInvoice.backImg"></upload-file>
<!--                    <span v-if="showTips" class="redColor">-->
<!--                    发票信息已更改，请确保已上传相应的营业执照-->
<!--                  </span>-->
                  </el-form-item>
                  <!--                <el-form-item label="盖公章的开票资料" prop="frontImg1" class="is-required img-item" v-if="imgRequired1">-->
<!--                  <el-form-item label="盖公章的开票资料" prop="" class="img-item" v-if="imgRequired1">
                    <div slot="label" style="display: inline-block;">
                      盖公章的<br>开票资料
                    </div>
                    <template v-if="activeInvoice.frontImg1">
                    <span class="yingye-img">
                      <img :src="getImgUrl(activeInvoice.frontImg1[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.frontImg1[0])">
                      <span class="del-icon" @click="delImg('frontImg1', 'frontImg1')"></span>
                    </span>
                    </template>
                    <template v-if="activeInvoice.backImg1">
                    <span class="yingye-img">
                      <img :src="getImgUrl(activeInvoice.backImg1[0].fileUrl)" alt="" @click="downloadFile(activeInvoice.backImg1[0])">
                      <span class="del-icon" @click="delImg('backImg1', 'frontImg1')"></span>
                    </span>
                    </template>
                    <upload-file bindKey="frontImg1" :apiUrl="host.javaUrl" :apis="apis" :limit="1" :type="1" v-model="activeInvoice.frontImg1" v-if="!activeInvoice.frontImg1"></upload-file>
                    <upload-file bindKey="backImg1" :apiUrl="host.javaUrl" :apis="apis" :limit="1" :type="1" v-model="activeInvoice.backImg1" v-if="!activeInvoice.backImg1"></upload-file>
                    &lt;!&ndash;                  <a class="redColor" style="text-decoration: underline;" href="https://publicfiles.sgsonline.com.cn/TIC/2022/06/%E5%BC%80%E7%A5%A8%E4%BF%A1%E6%81%AF%E5%8F%98%E6%9B%B4%E9%80%9A%E7%9F%A5%E4%B9%A6_1654571108512.docx">可以使用此参考模板编辑盖章后上传</a>&ndash;&gt;
                    <span v-if="showTips1" class="redColor" style="line-height: 1;">
                    发票信息已更改，请确保已上传相应的变更材料
                  </span>
                  </el-form-item>-->
                  <div class="check-notice" v-if="showNotice">
                    <el-checkbox v-model="checkNotice"></el-checkbox>
                    我已充分了解并确认<span class="redColor" style="cursor: pointer" @click="tipsVisible = true">《开具增值税发票确认书》</span>
                  </div>
                </template>
              </template>
              <el-form-item>
                <el-button type="primary" :loading="invoiceLoading" @click="saveInvoice">保存</el-button>
                <el-button @click="cancelEdit">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

    </div>
    <span slot="footer" class="dialog-footer" v-if="!isAdd && !isEdit">
      <!--<el-button @click="handleClose" :disabled="isAdd || isEdit">取消</el-button>-->
      <el-button type="primary" @click="handleSubmit" :disabled="!this.activeInvoice.invoiceId || loading">确定</el-button>
    </span>
    <el-dialog :visible.sync="imgDialogVisible" :append-to-body="true">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
    <invoice-notice v-model="tipsVisible" :checkNotice.sync="checkNotice"></invoice-notice>
  </el-dialog>
</template>

<script>
/**
 * 发票选择
 * */
import UploadFile from './UploadPrivateFileOcr.vue'
import pdfIcon from '../../assets/images/pdf-icon.png'
import InvoiceNotice from './InvoiceNotice.vue'
import {host} from "src/config";

export default {
  name: "TicInvoice",
  components: {
    UploadFile,
    InvoiceNotice
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    },
    env: {
      type: String,
      default: 'local'
    },
    isCs: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      const reg = /^[\d\s-+*#]+$/
      if (value && !reg.test(value.trim())) {
        return callback(new Error('格式错误'));
      } else if (this.activeInvoice.isForeign === 1 && !value) {
        return callback(new Error('请输入电话'))
      } else {
        return callback()
      }
    }
    const validateBank = (rule, value, callback) => {
      const reg = /^[0-9\-]{1,30}$/
      if (value && !reg.test(value)) {
        return callback(new Error('请输入1-30个数字'))
      } else {
        return callback()
      }
    }
    const validateImg = (rule, value, callback) => {
      const noImg = (!this.activeInvoice.frontImg || !this.activeInvoice.frontImg.length) && (!this.activeInvoice.backImg || !this.activeInvoice.backImg.length)
      if (noImg && this.activeInvoice.invoiceType !== 2 && this.activeInvoice.isForeign === 0 && this.imgRequired && this.activeInvoice.invoiceTitle && this.activeInvoice.taxNo) {
        this.invoiceLoading = true
        this.apis.checkCompany({
          company: this.activeInvoice.invoiceTitle,
          taxNo: this.activeInvoice.taxNo,
        }).then(res => {
          this.invoiceLoading = false
          this.imgRequiredShow = false
          callback()
        }).catch(e => {
          this.invoiceLoading = false
          this.$message.closeAll()
          this.imgRequiredShow = true
          if (e && e.resultCode === '3050') {
            callback(new Error(e.resultMsg))
          } else {
            callback(new Error('企业信息在工商数据库中校验不通过，请核对信息或者提供客户营业执照/组织机构代码证等材料'))
          }
          this.$nextTick(() => {
            this.$message.error('请上传营业执照')
          })
        })
      } else {
        this.imgRequiredShow = false
        return callback()
      }
    }
    const validateImg1 = (rule, value, callback) => {
      if  ((!this.activeInvoice.frontImg1 || !this.activeInvoice.frontImg1.length) && (!this.activeInvoice.backImg1 || !this.activeInvoice.backImg1.length)) {
        return callback(new Error('请上传盖公章的开票资料'))
      } else {
        return callback()
      }
    }
    const validateTaxNo = (rule, value, callback) => {
      if (this.invoiceType === 2) {
        const reg =/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (value.length !== 8 && value.length !== 10 && value.length !== 18) {
          return callback(new Error('请输入正确的身份证号码'));
        } else if (value.length === 18 && !reg.test(value)) {
          return callback(new Error('请输入正确的身份证号码'));
        } else {
          return callback()
        }
      } else {
        const reg = /^[\da-zA-Z]+$/
        if (this.activeInvoice.isForeign !== 1 && (value.length !== 15 && value.length !== 17 && value.length !== 18 && value.length !== 20 || !reg.test(value))) {
          return callback(new Error('纳税人识别号应为15、17、18或20位的数字和英文字母组合，请确认您的输入是否正确'));
        } else {
          if (this.showNotice || this.qryNoticeTaxNo[value]) {
            callback()
            return
          }
          this.apis.checkTaxNo({taxNo: value}).then(res => {
            this.qryNoticeTaxNo[value] = true
            if (res.data.isSure === 0) {
              this.showNotice = true
            }
            callback()
          }).catch(e => {
            this.showNotice = true
            callback()
          })
        }
      }
    }
    const validateEnNum = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9`~!@#$%^&*()_+|}{":?><,./;'\[\]\\=-\s]+$/
      if (value && this.activeInvoice.isForeign === 1 && !reg.test(value.trim())) {
        return callback(new Error('请输入英文字符数字'))
      } else {
        return callback()
      }
    }
    const validateEn = (rule, value, callback) => {
      const reg = /^[a-zA-Z`~!@#$%^&*()_+|}{":?><,./;'\[\]\\=-\s]+$/
      if (value && !reg.test(value.trim())) {
        return callback(new Error('请输入英文字符'))
      } else {
        return callback()
      }
    }
    // 全空格校验
    const validateEmpty = (rule, value, callback) => {
      if (value && !value.trim()) {
        return callback(new Error('请输入正确内容'))
      } else {
        return callback()
      }
    }
    return {
      host: host(this.env),
      isAbroad: false,
      dialogVisible: false,
      loading: true,
      list: [{}],
      list1: [{}],
      list2: [{}],
      list3: [{}],
      isAdd: false,
      isEdit: false,
      activeInvoice: {},
      form: {
        frontImg: '',
        backImg: ''
      },
      rules: {
        invoiceTitle: [
          { required: true, message: '必填项' },
          { validator: validateEnNum },
        ],
        regPhone: [{ required: false, message: '必填项' }, { validator: validatePhone }],
        taxNo: [{ required: true, message: '必填项' }, { validator: validateTaxNo, trigger: 'blur' }],
        backImg: [{ trigger: 'blur', validator: validateImg }],
        frontImg: [{ trigger: 'blur', validator: validateImg }],
        frontImg1: [{ trigger: 'change', validator: validateImg1 }],
        regAddress: [{ required: true, message: '必填项' }, { validator: validateEnNum }],
        bankName: [{ required: false, message: '必填项' }],
        bankNumber: [{ required: false, message: '必填项' }, { validator: validateBank }],
        country: [
          { required: true, message: '必填项', trigger: 'change', },
          { validator: validateEn, trigger: 'change' },
        ],
        foreignCity: [
          { required: true, message: '必填项', trigger: 'change', },
          { validator: validateEn, trigger: 'change' },
        ],
        postCode: [
          { required: true, message: '必填项', trigger: 'change', },
          { validator: validateEnNum, trigger: 'change' },
        ],
        contact: [
          { required: true, message: '必填项' },
          { validator: validateEn },
        ],
      },
      provice: [],
      props: {
        value: 'orgName',
        label: 'orgName',
        children: 'citys'
      },
      invoiceLoading: false,
      delLoading: false,
      isInit: false,
      type1: 1,
      type2: 1,
      imgDialogVisible: false,
      dialogImageUrl: '',
      invoiceById: {},
      pdfIcon,
      checkNotice: false,
      showNotice: false,
      qryNoticeTaxNo: {},
      tipsVisible: false,
      imgRequired: true,
      imgRequired1: false,
      isSelect: false,
      oldActiveInvoice: {},
      listSource: false,
      showTips: false,
      showTips1: false,
      currentOtherFile: [],
      titleTipsVisible: false,
      noTipsVisible: false,
      noList: false,
      imgRequiredShow: false
    }
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    invoiceType() {
      if (this.type1 === 2) {
        return 3
      }
      if (this.type1 === 1 && this.type2 === 1) {
        return 1
      }
      if (this.type1 === 1 && this.type2 === 2) {
        return 2
      }
    },
    isAddEdit() {
      return this.isAdd || this.isEdit
    }
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val
        if (val) {
          this.qryList()
          if (this.data.invoiceType === 1) {
            this.type1 = 1
            this.type1 = 1
          }
          if (this.data.invoiceType === 2) {
            this.type1 = 1
            this.type2 = 2
          }
          if (this.data.invoiceType === 3) {
            this.type1 = 2
          }
        }
      },
      immediate: true
    },
    invoiceType: {
      handler(val) {
        this.activeInvoice = {}
        if (val) {
          if (val === 1) {
            this.list = this.list1
          }
          if (val === 2) {
            this.list = this.list2
          }
          if (val === 3) {
            this.list = this.list3
          }
        }
      },
      immediate: true
    },
    isAddEdit: {
      handler(val) {
        if(!val) {
          this.checkNotice = false
          this.showNotice = false
          this.qryNoticeTaxNo = {}
        }
      }
    },
    activeInvoice: {
      handler(nVal, oVal) {
        this.imgRequired = false
        // console.log(nVal, oVal, this.oldActiveInvoice)
        if (
          nVal.invoiceTitle !== this.oldActiveInvoice.invoiceTitle ||
          nVal.taxNo !== this.oldActiveInvoice.taxNo
        ) {
          this.imgRequired = true
          // delete this.activeInvoice.frontImg1
          // delete this.activeInvoice.backImg1
          this.imgRequired1 = false
          this.showTips = this.oldActiveInvoice.frontImg || this.oldActiveInvoice.backImg
        } else if (
          nVal.regAddress !== this.oldActiveInvoice.regAddress ||
          nVal.regPhone !== this.oldActiveInvoice.regPhone ||
          nVal.bankName !== this.oldActiveInvoice.bankName ||
          nVal.bankNumber !== this.oldActiveInvoice.bankNumber
        ) {
          // if (this.isSelect) {
          //   this.imgRequired1 = true
          //   this.showTips = false
          //   this.showTips1 = this.oldActiveInvoice.otherFileList && this.oldActiveInvoice.otherFileList.length
          // }
        }
      },
      deep: true,
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    titleFocus(isFocus) {
      if (isFocus) this.noList = false
      const num = this.isCs ? 3 : 4
      this.titleTipsVisible = !this.activeInvoice.invoiceTitle || this.activeInvoice.invoiceTitle.length < num
    },
    noFocus() {
      this.noTipsVisible = !this.activeInvoice.taxNo || this.activeInvoice.taxNo.length < 5
    },
    getImgUrl(fileUrl) {
      if (!/\.(pdf|PDF)/.test(fileUrl)) {
        return fileUrl
      }
      return this.pdfIcon
    },
    // 预览发票图片
    downloadFile(data) {
      this.$set(data, 'downLoading', true)
      this.apis.getDownUrl({fileId: data.fileId}).then(res => {
        data.downLoading = false
        if (!/\.(pdf|PDF)/.test(res.data.fileUrl)) {
          this.dialogImageUrl = res.data.fileUrl
          this.imgDialogVisible = true
        } else {
          window.open(res.data.fileUrl)
        }
      }).catch(e => {
        data.downLoading = false
      })
    },
    querySearchAsync1(queryString, cb) {
      this.querySearchAsync(queryString, cb, true)
    },
    querySearchAsync(queryString, cb, isNo) {
      const queryLength = isNo ? 4 : this.isCs ? 2 : 3
      if (queryString && queryString.length > queryLength) {
        const data = {}
        if (isNo) {
          data.taxRegistrationNumber = queryString
        } else {
          data.word = queryString
          data.customerName = queryString
        }
        this.apis.getCust(data).then(res => {
          let result = []
          if (res.data.items && res.data.items.length) {
            result = res.data.items || []
          }
          this.noList = !result.length
          this.titleTipsVisible = this.noList
          cb(result)
        }).catch(e => {
          this.noList = true
          this.titleTipsVisible = true
          cb([])
        })
      } else {
        cb([])
      }
    },
    handleSelect(item) { // 选中输入建议
      this.titleTipsVisible = false
      this.noTipsVisible = false
      if (this.isCs) {
        this.activeInvoice.invoiceTitle = item.customerNameCn
        this.activeInvoice.taxNo = item.taxRegistrationNumber
        this.activeInvoice.regAddress = item.addressCn
        this.activeInvoice.regPhone = item.telephone
        this.activeInvoice.bankName = `${item.bankName}(${item.bankBranchName})`
        this.activeInvoice.bankNumber = item.bankAccountNum
        this.activeInvoice.bossNo = item.number
      } else {
        this.activeInvoice.invoiceTitle = item.name
        this.activeInvoice.taxNo = item.creditCode
      }
      this.activeInvoice = Object.assign({}, this.activeInvoice)
      this.oldActiveInvoice = JSON.parse(JSON.stringify(this.activeInvoice))
      // this.listSource = false
      this.$nextTick(() => {
        this.imgRequired = false
        // this.imgRequired1 = false
        this.isSelect = true
      })
    },
    delImg(key, key1) {
      delete this.activeInvoice[key]
      this.activeInvoice = Object.assign({}, this.activeInvoice)
      // this.validateImg(key1)
    },
    validateImg(key) {
      // this.$refs.ruleForm.validateField(key)
    },
    cancelEdit() {
      if (this.isEdit) {
        const val = Object.assign({}, this.invoiceById[this.activeInvoice.invoiceId])
        this.activeInvoice = this.getImg(val)
      }
      this.isAdd = false
      this.isEdit = false
    },
    handleKeydown() {
      if (this.$refs.cascader.suggestions.length) {
        this.$refs.cascader.handleSuggestionClick(0)
      }
    },
    getImg(data) {
      if (data.invoiceType === 2) {
        return data
      }
      let val = Object.assign({}, data)
      if (val.frontImg) {
        this.apis.getDownUrl({ fileId: val.frontImg })
          .then((res) => {
            let d = [
              {
                fileUrl: res.data.fileUrl,
                fileId: data.frontImg,
              },
            ]
            this.$set(val, 'frontImg', d)
          })
          .catch((e) => {})
      } else {
        delete this.activeInvoice.frontImg
      }
      if (val.backImg) {
        this.apis.getDownUrl({ fileId: val.backImg })
          .then((res) => {
            let d = [
              {
                fileUrl: res.data.fileUrl,
                fileId: data.backImg,
              },
            ]
            this.$set(val, 'backImg', d)
          })
          .catch((e) => {})
      } else {
        delete this.activeInvoice.backImg
      }
      this.currentOtherFile = []
      val.otherFileList && val.otherFileList.forEach((v, index) => {
        console.log(v)
        this.apis.getDownUrl({ fileId: v.fileId })
          .then((res) => {
            v.fileUrl = res.data.fileUrl
            this.$set(v, 'fileUrl', res.data.fileUrl)
            this.currentOtherFile.push(v)
            const key = index === 0 ? 'frontImg1' : 'backImg1'
            val[key] = [v]
            this.$set(val, key, [v])
            this.$set(this.activeInvoice, key, [v])
          })
          .catch((e) => {})
      })
      return val
    },
    chooseInvoice(data) {
      if (this.isEdit || this.isAdd) {
        return
      }
      const val = Object.assign({}, data)
      this.activeInvoice = this.getImg(val)
    },
    editInvoice(list) {
      this.imgRequiredShow = false
      this.isEdit = true
      const val = Object.assign({}, list)
      if (val.otherFileList && val.otherFileList[0]) {
        val.frontImg1 = [val.otherFileList[0]]
      }
      if (val.otherFileList && val.otherFileList[1]) {
        val.backImg1 = [val.otherFileList[1]]
      }
      this.activeInvoice = this.getImg(val)
      this.oldActiveInvoice = {}
      // this.oldActiveInvoice = JSON.parse(JSON.stringify(this.activeInvoice))
      this.listSource = true
      this.showTips = false
      this.showTips1 = false
      this.isedit = true
      this.$nextTick(() => {
        this.imgRequired = true
        // this.imgRequired1 = list.otherFileList && list.otherFileList.length
        // this.isSelect = true
      })
    },
    addInvoice() {
      this.isAdd = true
      this.activeInvoice = {
        isForeign: 0
      }
      this.oldActiveInvoice = {}
      this.imgRequired = true
      this.imgRequired1 = false
      this.listSource = false
      this.showTips = false
      this.showTips1 = false
      this.imgRequiredShow = false
    },
    saveInvoice() {
      try{
        this.invoiceLoading = true
        this.$refs.ruleForm[0].validate((valid) => {
          if (valid) {
            if (this.showNotice && !this.checkNotice) {
              this.invoiceLoading = false
              // this.$alert('请确认《开具增值税发票确认书》', '', { confirmButtonText: '确定', center: true });
              this.tipsVisible = true
              return
            }
            let data = {}
            if (this.activeInvoice.isForeign === 1) {
              data = {
                country: this.activeInvoice.country,
                foreignCity: this.activeInvoice.foreignCity,
                regAddress: this.activeInvoice.regAddress,
                postCode: this.activeInvoice.postCode,
                contact: this.activeInvoice.contact,
                regPhone: this.activeInvoice.regPhone,
                isForeign: this.activeInvoice.isForeign,
                invoiceType: this.invoiceType,
                invoiceId: this.activeInvoice.invoiceId,
                invoiceTitle: this.activeInvoice.invoiceTitle,
              }
            } else {
              data = {
                invoiceType: this.invoiceType,
                invoiceTitle: this.activeInvoice.invoiceTitle,
                taxNo: this.activeInvoice.taxNo,
                regAddress: this.activeInvoice.regAddress,
                regPhone: this.activeInvoice.regPhone,
                bankName: this.activeInvoice.bankName,
                bankNumber: this.activeInvoice.bankNumber,
                invoiceId: this.activeInvoice.invoiceId,
                bossNo: this.activeInvoice.bossNo,
                isForeign: this.activeInvoice.isForeign
              }
              if (this.invoiceType !== 2) {
                data.backImg = this.activeInvoice.backImg ? this.activeInvoice.backImg.map(v => v.fileId).join(',') : ''
                data.frontImg = this.activeInvoice.frontImg ? this.activeInvoice.frontImg.map(v => v.fileId).join(',') : ''
                data.otherFileList = []
                if (this.activeInvoice.frontImg1 && this.activeInvoice.frontImg1.length) {
                  data.otherFileList.push(this.activeInvoice.frontImg1[0])
                }
                if (this.activeInvoice.backImg1 && this.activeInvoice.backImg1.length) {
                  data.otherFileList.push(this.activeInvoice.backImg1[0])
                }
              } else {
                data.backImg = this.activeInvoice.backImg
                data.frontImg = this.activeInvoice.frontImg
                delete data.isForeign
              }
            }
            data.isEdit = !this.isAdd
            this.apis.saveInvoice(data).then(res => {
              this.$message.success('操作成功')
              this.invoiceLoading = false
              if (this.isAdd) {
                this.qryList(true)
              } else {
                this.qryList()
              }
              this.isAdd = false
              this.isEdit = false
            }).catch(e => {
              this.invoiceLoading = false
            })
          } else {
            this.invoiceLoading = false
            this.$message.error('请填写必填项')
            return false;
          }
        })
      } catch (e) {
        console.log(e)
        this.invoiceLoading = false
      }
    },
    delInvoice(invoiceId) {
      this.$confirm('确认删除？', '提示', {
        confirmButtonText: '确定',
        type: 'warning',
        center: true,
        showClose: false
      }).then(() => {
        this.delLoading = true
        this.apis.delInvoice({ invoiceId }).then(res => {
          this.$message.success('删除成功')
          this.delLoading = false
          this.qryList()
          if (this.data.invoiceId === invoiceId) {
            this.$emit('update:data', {})
          }
        }).catch(e => {
          this.delLoading = false
        })
      }).catch()
    },
    qryList(isAdd) {
      this.loading = true
      this.apis.qryInvoiceList({
        pageRow: 999,
        pageNum: 1
      }).then(res => {
        const key = 'list' + this.invoiceType
        this.list1 = []
        this.list2 = []
        this.list3 = []
        const invoiceById = {}
        res.data.items.forEach(v => {
          invoiceById[v.invoiceId] = v
          if (v.invoiceType === 1 || v.invoiceType === 3 ) {
            this.list1.push(v)
            this.list3.push(v)
          }
          if (v.invoiceType === 2) {
            this.list2.push(v)
          }
          // if (v.invoiceType === 3) {
          //   this.list3.push(v)
          // }
        })
        this.list1.push({})
        this.list2.push({})
        this.list3.push({})
        this.list = this[key]
        this.invoiceById = invoiceById
        let val = {}
        if (!this.activeInvoice.invoiceId) {
          if (this.data.invoiceId && invoiceById[this.data.invoiceId]) {
            val = Object.assign({}, invoiceById[this.data.invoiceId])
          } else {
            val = Object.assign({}, this.list1[0])
          }
        }
        if (isAdd) {
          val = Object.assign({}, this[key][this[key].length - 2])
        }
        if (val.invoiceId) {
          this.activeInvoice = this.getImg(val)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
      })
    },
    handleCancel() {
    },
    handleClose() {
      this.dialogVisible = false
      this.$emit('input', false)
      this.isAdd = false
      this.isEdit = false
      this.activeInvoice = {}
      this.isInit = false
    },
    handleSubmit() {
      const invoice = JSON.parse(JSON.stringify(this.activeInvoice))
      if (invoice.frontImg && typeof invoice.frontImg !== 'string') invoice.frontImg = invoice.frontImg.map(v => v.fileId).join(',')
      if (invoice.backImg && typeof invoice.backImg !== 'string') invoice.backImg = invoice.backImg.map(v => v.fileId).join(',')
      invoice.invoiceType = this.invoiceType
      // 传递选中的类型到父组件
      if(this.type1==1&&this.activeInvoice.invoiceType==3){
        this.$confirm('该公司抬头曾开具过增值税专用发票，您确定本次要开具增值税普通发票吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$emit('update:data', Object.assign({}, invoice))
          this.handleClose()
        }).catch(() => {
          this.handleClose()
        });
      }else{
        this.$emit('update:data', Object.assign({}, invoice))
        this.handleClose()
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .invoice-person {
    font-size: 14px;
    color: #333333;
    margin-top: 20px;
  }
  .check-notice {
    text-align: center;
    margin-bottom: 22px;
  }
</style>
<style lang="scss">
  .invoice-dialog {
    .el-form-item__error {
      position: static;
    }
    .el-dialog__header {
      padding: 25px 50px 21px 50px;
      border-bottom: 1px solid #D2D2D2;
      font-size: 18px;
      color: #333333;
      line-height: 18px;
      .el-dialog__headerbtn {
        top: 25px;
        font-size: 23px;
        right: 29px;
      }
      .title-tips {
        font-size: 14px;
        color: #FF0000;
        line-height: 18px;
      }
    }
    .el-dialog__body {
      padding: 30px 50px 40px 50px;
      .invoice-list {
        /*display: flex;*/
        .invoice-list-item {
          display: flex;
        }
        .invoice-item {
          display: flex;
          &:hover .edit-btn {
            display: block;
          }
          &.is-disabled {
            .invoice-item-detail {
              cursor: not-allowed;
            }
            .edit-btn {
              display: none;
            }
          }
        }
        .invoice-item-detail {
          width: 310px;
          height: 30px;
          border: 1px solid #BFBFBF;
          padding: 0 17px;
          font-size: 14px;
          color: #333333;
          line-height: 28px;
          white-space:nowrap;/* 规定文本是否折行 */
          overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
          text-overflow: ellipsis;
          margin-bottom: 6px;
          cursor: pointer;
          position: relative;
          margin-right: 24px;
          img {
            display: none;
            position: absolute;
            bottom: 0;
            right: 0;
          }
          &.is-active {
            border: 2px solid #ca4300;
            img {
              display: block;
            }
          }
        }
        .edit-btn {
          font-size: 14px;
          color: #2828C0;
          line-height: 30px;
          /*display: none;*/
          cursor: pointer;
        }
        .add-btn {
          font-size: 14px;
          color: #ca4300;
          line-height: 30px;
          cursor: pointer;
          .add-btn-icon {
            display: inline-block;
            width: 18px;
            height: 18px;
            background: #FFFFFF;
            border: 2px solid #ca4300;
            border-radius: 50%;
            font-size: 18px;
            font-weight: bold;
            color: #ca4300;
            line-height: 14px;
            margin-top: 6px;
            text-align: center;
            margin-right: 10px;
          }
        }
      }
      .edit-invoice {
        display: flex;
        margin-top: 14px;
      }
      .label {
        width: 56px;
        height: 30px;
        font-size: 14px;
        color: #333333;
        line-height: 30px;
        margin-right: 28px;
      }
      .invoice-detail {
        font-size: 14px;
        color: #333333;
        line-height: 18px;
        display: flex;
        margin-top: 14px;
        margin-bottom: 10px;
        .detail-item {
          margin-bottom: 10px;
        }
        .detail-label {
          margin-right: 10px;
          display: inline-block;
          width: 84px;
        }
      }
    }
    .el-dialog__footer {
      padding: 0;
      padding-bottom: 33px;
      text-align: center;
      .el-button {
        width: 120px;
        height: 38px;
        border-radius: 0;
      }
    }
    .invoice-form {
      width: 510px;
      /*height: 377px;*/
      background: #FFFFFF;
      border: 1px solid #BFBFBF;
      padding: 0;
      margin-bottom: 20px;
      .form-title {
        height: 36px;
        background: #FAFAFA;
        font-size: 14px;
        font-weight: bold;
        color: #878787;
        line-height: 36px;
        padding: 0 18px;
        margin-bottom: 21px;
      }
      .upload-tips {
        font-size: 14px;
        color: #333333;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 10px;
        padding-left: 18px;
      }
      .el-form-item {
        border: none;
        padding: 0 26px 0 18px;
        margin-bottom: 22px;
        &:first-child {
          margin-top: 21px;
        }
        &.img-item {
          .el-form-item__label {
            line-height: 1;
          }
          .el-form-item__error {
            position: absolute;
          }
        }
      }
      .el-form-item__label {
        line-height: 36px;
        text-align: left;
        font-size: 14px;
        font-weight: normal;
        position: relative;
        // .tip-icon {
        //   position: absolute;
        //   width: 14px;
        //   height: 14px;
        //   background: #FF0000;
        //   border-radius: 50%;
        //   font-size: 13px;
        //   font-weight: bold;
        //   color: #FFFFFF;
        //   line-height: 14px;
        //   padding-left: 4px;
        //   top: 11px;
        //   right: 6px;
        //   cursor: pointer;
        // }
      }
      .el-form-item__content {
        display: flex;
        flex-wrap: wrap;
      }
      .el-input__inner {
        height: 36px;
        border-color: #BFBFBF;
        border-radius: 0;
      }
      .el-button {
        width: 60px;
        height: 32px;
        border-radius: 5px;
        padding: 0;
        text-align: center;
      }
    }
    .invoice-type {
      display: flex;
      margin-bottom: 10px;
      .el-radio {
        line-height: 30px;
      }
    }
    .yingye-img {
      display: inline-block;
      width: 60px;
      height: 60px;
      background: #FFFFFF;
      border: 1px solid #D2D2D2;
      text-align: center;
      margin-right: 20px;
      position: relative;
      img {
        /*width: 40px;
        height: 58px;*/
        max-height: 58px;
        max-width: 58px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .sfz-img {
      width: 60px;
      height: 60px;
      background: #FFFFFF;
      border: 1px solid #D2D2D2;
      text-align: center;
      /*margin-right: 13px;*/
      display: block;
      img {
        /*width: 55px;*/
        /*height: 34px;*/
        /*margin-top: 13px;*/
        max-height: 58px;
        max-width: 58px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
    }
    .yingye-img, .sfz-img {
      position: relative;
      .del-icon {
        position: absolute;
        width: 16px;
        height: 16px;
        background: url("../../assets/images/delEmail.png");
        top: 2px;
        right: 2px;
        cursor: pointer;
        z-index: 1;
      }
    }
    .sfz-tips {
      font-size: 12px;
      color: #878787;
      line-height: 60px;
      margin-left: 20px;
    }
    .detail-list {
      flex: 1;
      .detail-item {
        display: flex;
        .detail-content {
          flex: 1;
        }
      }
    }
  }
</style>
